import axios from 'axios'
import { toast } from 'react-toastify'
import requestConfigs, { getPath, getRequestRequirement } from './requestConfig'
import ToastMessage from '../components/ToastMessage'
const paseUrl = process.env.REACT_APP_API_ENDPOINT + requestConfigs.prefix + requestConfigs.varsion

let use_T = null
// const Client = require("whmcs-api")

const apiClient = axios.create({
  baseURL: paseUrl,
  // timeout: 10000, 
  // headers: {
  //   'Content-Type': 'application/json'
  // },
});

let requirement = {};
export const initialAxiosInstance = (token, lng, tenantId) => {

  apiClient.defaults.headers.Accept = 'application/json'
  apiClient.defaults.baseURL = paseUrl
  apiClient.defaults.headers.common['Accept-Language'] = lng ? lng : localStorage.getItem('i18nextLng')

  apiClient.interceptors.request.use(
    (config) => {
      const accessToken = token ? token : localStorage.getItem('accessToken')
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`

      }
      if (localStorage.getItem("sipOnlineUser")) {
        const tenant = tenantId ? tenantId : JSON.parse(localStorage.getItem("sipOnlineUser"))?.tenants[0]?.tenantId
        config.headers.TenantID = tenant

      }
      return config
    },
    (err) => Promise.reject(err),
  )
  apiClient.defaults.withCredentials = true
  apiClient.interceptors.response.use(
    (response) => response,
    (err) => {
      if (err.response.status === 401) {
        localStorage.removeItem('sipOnlineUser')
        localStorage.removeItem('accessToken')
        if (window.location.hash !== '#/getPassword') {
          window.location = '/login'
        }
      }
      if (requirement.action.enable_message) {
        ToastMessage.error(
          err.response && err.response.data && err.response.data.title
            ? err.response.data.title
            : 'Unspecified error occurrence',
        )
      }
      return { ...err, option: requirement.action }
    },
  )

}

initialAxiosInstance()

export default apiClient

const apiRunnerToastHandler = (params, status, requirement, whmcsAction) => {
  if (whmcsAction === 'AddTicketReply') {
    if (status === 200) {
      ToastMessage.success(use_T(requirement.action.successReplayMessage))
    } else {
      ToastMessage.error(use_T(requirement.action.errorReplayMessage))
    }
  } else if (whmcsAction === 'OpenTicket') {
    if (status === 200) {
      ToastMessage.success(use_T(requirement.action.successCreateTicketMessage))
    } else {
      ToastMessage.error(use_T(requirement.action.errorCreateTicketMessage))
    }
  }
}

export const apiRequest = async (path, params = {}, pathParams = '', whmcsAction) => {
  requirement = getRequestRequirement(path)
  switch (requirement.action.method) {
    case 'post': {
      const response = await apiClient.post(requirement.path + pathParams, params)

      if (path === "APIRunner.TestApiRunner") {
        apiRunnerToastHandler(params, response.status, requirement, whmcsAction)
        return { ...response, option: requirement.action }

      } else {
        if (response.status === 200 && requirement.action.enable_message) {
          const temp = use_T(requirement.action.successMessage)
          ToastMessage.success(use_T(requirement.action.successMessage))
          return { ...response, option: requirement.action }

        } else if (response.status === 200) {
          return { ...response, option: requirement.action }

        }
        else {
          if (requirement.action.errorMessage) {

            if (response.response.data.title) {
              ToastMessage.error(use_T(response.response.data.title))

            } else {
              ToastMessage.error(use_T(requirement.action.errorMessage))

            }

          }
          throw { ...response, option: requirement.action }
        }
      }
    }



    case 'get':
      {
        if (requirement.path.split('/')[0] === "chat") {
          apiClient.defaults.baseURL = `${process.env.REACT_APP_CHAT}/api`
        }
        const response = await apiClient.get(requirement.path + pathParams, params)
        if ((response.status === 200 || response.status === 204) && requirement.action.enable_message) {
          ToastMessage.success(use_T(requirement.action.successMessage))
          return { ...response, option: requirement.action }
        } else if (response.status === 200) {
          return { ...response, option: requirement.action }
        } else {
          if (requirement.action.errorMessage) {
            if (response.response.data.title) {
              ToastMessage.error(use_T(response.response.data.title))
            } else {
              ToastMessage.error(use_T(requirement.action.errorMessage))
            }
          }
          throw { ...response, option: requirement.action }
        }
      }




    case 'put': {
      const response = await apiClient.put(requirement.path + pathParams, params)

      if (
        (response.status === 200 || response.status === 204) &&
        requirement.action.enable_message
      ) {
        ToastMessage.success(use_T(requirement.action.successMessage))
        return { ...response, option: requirement.action }
      } else if (response.status === 200 || response.status === 204) {
        return { ...response, option: requirement.action }
      } else {
        throw { ...response, option: requirement.action }
      }
    }
    case 'delete': {
      const response = await apiClient.delete(requirement.path + pathParams)
      if (
        (response.status === 200 || response.status === 204) &&
        requirement.action.enable_message
      ) {
        ToastMessage.success(use_T(requirement.action.successMessage))
        return { ...response, option: requirement.action }
      } else if (response.status === 200 || response.status === 204) {
        return { ...response, option: requirement.action }
      } else {
        throw { ...response, option: requirement.action }
      }
    }
    default:
      throw 'Method not found'
  }
}

export const initialUseTranslation = (_use_T) => {
  use_T = _use_T
}

export const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB

export const PackageInvoiceDBConfig = {
  name: 'Dartamas-DB',
  version: 1,
  objectStoresMeta: [
    {
      store: 'invoice',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'userId', keypath: 'userId', options: { unique: false } },
        { name: 'invoiceId', keypath: 'invoiceId', options: { unique: true } },
        { name: 'packageTypeId', keypath: 'packageTypeId', options: { unique: false } },
        { name: 'durationId', keypath: 'durationId', options: { unique: false } },
      ],
    },
  ],
};

export const setAPIRequestHeaders = (headers) => {
  apiClient.defaults.headers.common['Authorization'] = headers
}

export const setTenantToHeader = () => {
  if (localStorage.getItem("sipOnlineUser")) {
    const tenant = JSON.parse(localStorage.getItem("sipOnlineUser"))?.tenants[0]?.tenantId
    apiClient.defaults.headers.common['TenantID'] = tenant

  } else {
    setTenantToHeader()
  }
}

export const initialAxiosInstanceByBaseUel = (_baseUrl) => {


  const _apiClient = axios.create({
    baseURL: _baseUrl,
    headers: {
      'Content-Type': 'application/json'
    },
  });

  _apiClient.defaults.headers.Accept = 'application/json'
  _apiClient.defaults.baseURL = _baseUrl
  _apiClient.defaults.headers.common['Accept-Language'] =  localStorage.getItem('i18nextLng')

  _apiClient.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem('accessToken')
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`

      }
      if (localStorage.getItem("sipOnlineUser")) {
        const tenant = JSON.parse(localStorage.getItem("sipOnlineUser"))?.tenants[0]?.tenantId
        config.headers.TenantID = tenant

      }
      return config
    },
    (err) => Promise.reject(err),
  )
  _apiClient.defaults.withCredentials = true
  _apiClient.interceptors.response.use(
    (response) => response,
    (err) => {
      if (err.response.status === 401) {
        localStorage.removeItem('sipOnlineUser')
        localStorage.removeItem('accessToken')
        if (window.location.hash !== '#/getPassword') {
          window.location = '/login'
        }
      }
      if (requirement.action.enable_message) {
        ToastMessage.error(
          err.response && err.response.data && err.response.data.title
            ? err.response.data.title
            : 'Unspecified error occurrence',
        )
      }
      return { ...err, option: requirement.action }
    },
  )
  
return _apiClient;
}
